import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { radius, space } from '@elementary/common-ui/style/utils';

const SettingsSection = styled(FlexColumn)`
  border: 1px solid ${({ theme }) => theme.palette.border.subtle};
  border-radius: ${radius('md')};
  padding: ${space('xxxl')};
`;

export default SettingsSection;
